import { persist } from 'zustand/middleware';
import { IAppState } from './interface';
import { create } from 'zustand';
import { LangEnum } from '@/lang/enum';
import { IUerInfo } from '@/request/referral/referral.response.interface';
import { CHAIN_LIST } from '../config/chainConfig';
import { IChainInfo } from '@/interface';

export const useAppStore = create<IAppState>()(
  persist(
    (set, _) => ({
      lang: LangEnum.EN,
      chainInfo: CHAIN_LIST[0],
      chainTokenAddressMap: {
        sol: '74SBV4zDXxTRgv1pEMoECskKBkZHc2yGPnc7GYVepump',
        bsc: '0x5c85d6c6825ab4032337f11ee92a72df936b46f6',
      },
      fakeLoginState: false,
      oneWalletOpen: false,
      fwClass: 'en-fw',
      userIds: [],
      chainCoinPrice: 0,
      chainCoinBalance: 0,
      depositOpen: false,
      withdrawOpen: false,
      totalBalance: '0',
      followWalletAddressList: [],
      followTokenAddressList: [],
      profile: null,
      tokenPath: '',
      setLang: (lang: LangEnum) => set({ lang }),
      setFwClass: (fwClass: string) => set({ fwClass }),
      setChainInfo: (chainInfo: IChainInfo) => set({ chainInfo }),
      setUserId: (userId: string) => set({ userIds: [userId] }),
      setChainCoinPrice: (chainCoinPrice: string | number) => set({ chainCoinPrice }),
      setChainCoinBalance: (chainCoinBalance: string | number) => set({ chainCoinBalance }),
      setDepositOpen: (depositOpen: boolean) => set({ depositOpen }),
      setWithdrawOpen: (withdrawOpen: boolean) => set({ withdrawOpen }),
      setTotalBalance: (totalBalance: string) => set({ totalBalance }),
      setFollowWalletAddressList: (followWalletAddressList: string[]) => set({ followWalletAddressList }),
      setFollowTokenAddressList: (followTokenAddressList: string[]) => set({ followTokenAddressList }),
      setProfile: (profile: IUerInfo | null) => set({ profile }),
      setTokenPath: (tokenPath: string) => set({ tokenPath }),
      setChainTokenAddressMap: (chain, tokenAddress) =>
        set((state) => ({
          chainTokenAddressMap: {
            ...state.chainTokenAddressMap,
            [chain]: tokenAddress,
          },
        })),
    }),
    {
      name: 'app_store',
    },
  ),
);
